export default __webpack_public_path__ + "static/media/flowerlight.486f7558.png";